<template>
    <div class="alkine">
        <ul>
            <li>C<sub>n</sub>H<sub>2n-2</sub></li>
            <li>sp<sup>1</sup> hybridisiert</li>
            <li>unpolar</li>
            <li>rußende Flamme bei Verbrennung</li>
            <li>-in</li>
            <li>Additionsreaktion zweimal</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'alkine',
};
</script>
